import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core'
import { Daterange } from '@northfork/ng-basics'
import { Subject } from 'rxjs'
import { InterestFormat } from '../../models/accrued-interest.model'

@Component({
  selector: 'hs-accrued-interest-properties',
  styleUrls: ['./accrued-interest-properties.component.scss'],
  templateUrl: './accrued-interest-properties.component.html',
})
export class AccruedInterestPropertiesComponent implements OnDestroy {
  private readonly _destroyed$ = new Subject<void>()
  private _interestFormat: InterestFormat = InterestFormat.Decimal

  @Input() set dateRange(dateRange: Daterange | null) {
    this._dateRange = dateRange
    this.buildCurrentProperties()
  }

  @Input() set interestFormat(format: InterestFormat | null) {
    this.interestFormatToggle = format === InterestFormat.Dollar
  }

  @Output() dateRangeChange = new EventEmitter<Daterange>()
  @Output() interestFormatChange = new EventEmitter<InterestFormat>()

  _dateRange: Daterange | null = null
  currentProperties: string[] = []
  interestFormatToggle = false

  ngOnDestroy() {
    this._destroyed$.next()
    this._destroyed$.complete()
  }

  onInterestFormatChanged(isDollarInterestFormat: boolean) {
    if (isDollarInterestFormat) {
      this._interestFormat = InterestFormat.Dollar
    } else {
      this._interestFormat = InterestFormat.Decimal
    }
    this.interestFormatChange.emit(this._interestFormat)
    this.buildCurrentProperties()
  }

  onDateRangeChanged(newDateRange: Daterange) {
    this.dateRangeChange.emit(newDateRange)
  }

  private buildCurrentProperties() {
    const properties = []
    switch (this._interestFormat) {
      case InterestFormat.Decimal:
        properties.push('Accrued Interest: Decimal Rates')
        break
      case InterestFormat.Dollar:
        properties.push('Accrued Interest: Dollar Amounts')
        break
    }

    this.currentProperties = properties
  }
}
